export default __webpack_public_path__ + "static/media/envio-black.5238a769.png";